module.exports = __webpack_public_path__ + "img/Linda_Ifea_small.b99af7eb.jpg";